import { AudioEditor } from "../../AudioEditor";
import { ExportSettings } from "./ExportSettings";
import { Namer } from "./Namer";
import { Slicing } from "./Slicing";
import { SlicingModeType } from "./SlicingMode";
import { Trimming } from "./Trimming";

export class ClipCreator
{
  editor:AudioEditor;
  settings:ExportSettings;  

  async generateExportClips():Promise<void>
  {
    console.log( "Slicing" );

    let slicing = new Slicing();
    slicing.exporter = this;
    
    await slicing.slice();

    let trimmer = new Trimming();
    trimmer.exporter = this;

    await trimmer.trim();

    console.log( "Naming" );

    let namer = new Namer();
    namer.exporter = this;

    await namer.nameExports();

    console.log( "Updating Inspector" );
    
    this.editor.updateInspector(); 

    return Promise.resolve();
  }

  async exportAudio():Promise<void>
  {
    let worker = new Worker( new URL("./RecorderWorker.ts", import.meta.url) );
  }

  
}